import {
  HandlingUnit,
  InvoiceLineItem,
} from "../../../../api/invoices/interfaces";

export default function buildInvoiceLineItemData({
  invoiceNumber,
  originalInvoiceNumber,
  nfeNumber,
  originalNfeNumber,
  isCreditOrDebitMemo,
  includeNFE,
  invoiceLineItems,
  showFlashPlusCharge,
  headerTexts,
}: {
  invoiceNumber: string;
  originalInvoiceNumber: string;
  nfeNumber: string;
  originalNfeNumber: string;
  showFlashPlusCharge: boolean;
  headerTexts: {
    invoiceNumberHeaderTexts: {
      invoiceNumberText: string;
      newInvoiceNumberText: string;
    };
    nfeNumberHeaderTexts: {
      nfeNumberText: string;
      newNfeNumberText: string;
    };
    lineItemsHeaderTexts: {
      documentNumber: string;
      dealerReference: string;
      handlingUnit: string;
      partNumber: string;
      description: string;
      quanitity: string;
      unitPrice: string;
      extendedDiscount: string;
      surcharge: string;
      freightCost: string;
      extendedAmount: string;
    };
  };
  isCreditOrDebitMemo: boolean;
  includeNFE: boolean;
  invoiceLineItems: InvoiceLineItem[];
}) {
  const headers = buildHeaders({
    isCreditOrDebitMemo,
    headerTexts,
    includeNFE,
    showFlashPlusCharge,
  });
  const lineItems = invoiceLineItems.flatMap((lineItem) => {
    const invoiceNumbers: string[] = [];
    const nfeNumbers: string[] = [];
    if (isCreditOrDebitMemo) {
      invoiceNumbers.push(originalInvoiceNumber);
      invoiceNumbers.push(invoiceNumber);
    } else {
      invoiceNumbers.push(invoiceNumber);
    }
    if (includeNFE) {
      if (isCreditOrDebitMemo) {
        nfeNumbers.push(originalNfeNumber);
        nfeNumbers.push(nfeNumber);
      } else {
        nfeNumbers.push(nfeNumber);
      }
    }
    const surchargeData = showFlashPlusCharge
      ? [lineItem.flashPlusCharges, lineItem.freightCharges]
      : [lineItem.freightCharges];
    if (lineItem.handlingUnits.length > 0) {
      return lineItem.handlingUnits.map((handlingUnit) => [
        ...invoiceNumbers,
        ...nfeNumbers,
        lineItem.documentNumber,
        lineItem.orderType,
        lineItem.dealerReference?.replace(/,/g, ";"),
        getHandlingUnit(handlingUnit),
        lineItem.partNumber,
        lineItem.description?.replace(/,/g, ";"),
        lineItem.quantity,
        lineItem.unitPrice,
        lineItem.extendedDiscount,
        ...surchargeData,
        lineItem.extendedAmount,
      ]);
    }
    return [
      [
        ...invoiceNumbers,
        ...nfeNumbers,
        lineItem.documentNumber,
        lineItem.orderType,
        lineItem.dealerReference?.replace(/,/g, ";"),
        "",
        lineItem.partNumber,
        lineItem.description?.replace(/,/g, ";"),
        lineItem.quantity,
        lineItem.unitPrice,
        lineItem.extendedDiscount,
        ...surchargeData,
        lineItem.extendedAmount,
      ],
    ];
  });
  return [[...headers], ...lineItems];
}

function buildHeaders({
  isCreditOrDebitMemo,
  headerTexts: {
    invoiceNumberHeaderTexts,
    nfeNumberHeaderTexts,
    lineItemsHeaderTexts,
  },
  includeNFE,
  showFlashPlusCharge,
}: {
  isCreditOrDebitMemo: boolean;
  headerTexts: {
    invoiceNumberHeaderTexts: {
      invoiceNumberText: string;
      newInvoiceNumberText: string;
    };
    nfeNumberHeaderTexts: {
      nfeNumberText: string;
      newNfeNumberText: string;
    };
    lineItemsHeaderTexts: {
      documentNumber: string;
      dealerReference: string;
      handlingUnit: string;
      partNumber: string;
      description: string;
      quanitity: string;
      unitPrice: string;
      extendedDiscount: string;
      surcharge: string;
      freightCost: string;
      extendedAmount: string;
    };
  };
  includeNFE: boolean;
  showFlashPlusCharge: boolean;
}) {
  const invoiceNumberHeaders: string[] = [
    invoiceNumberHeaderTexts.invoiceNumberText,
  ];
  if (isCreditOrDebitMemo) {
    invoiceNumberHeaders.push(invoiceNumberHeaderTexts.newInvoiceNumberText);
  }
  const nfeHeaders: string[] = [];
  if (includeNFE) {
    nfeHeaders.push(nfeNumberHeaderTexts.nfeNumberText);
    if (isCreditOrDebitMemo) {
      nfeHeaders.push(nfeNumberHeaderTexts.newNfeNumberText);
    }
  }
  const lineItemsHeader = showFlashPlusCharge
    ? [
        lineItemsHeaderTexts.documentNumber,
        lineItemsHeaderTexts.dealerReference,
        lineItemsHeaderTexts.handlingUnit,
        lineItemsHeaderTexts.partNumber,
        lineItemsHeaderTexts.description,
        lineItemsHeaderTexts.quanitity,
        lineItemsHeaderTexts.unitPrice,
        lineItemsHeaderTexts.extendedDiscount,
        lineItemsHeaderTexts.surcharge,
        lineItemsHeaderTexts.freightCost,
        lineItemsHeaderTexts.extendedAmount,
      ]
    : [
        lineItemsHeaderTexts.documentNumber,
        lineItemsHeaderTexts.dealerReference,
        lineItemsHeaderTexts.handlingUnit,
        lineItemsHeaderTexts.partNumber,
        lineItemsHeaderTexts.description,
        lineItemsHeaderTexts.quanitity,
        lineItemsHeaderTexts.unitPrice,
        lineItemsHeaderTexts.extendedDiscount,
        lineItemsHeaderTexts.surcharge,
        lineItemsHeaderTexts.extendedAmount,
      ];

  return [...invoiceNumberHeaders, ...nfeHeaders, ...lineItemsHeader];
}

function getHandlingUnit(handlingUnit: HandlingUnit) {
  return `${handlingUnit.number} (${handlingUnit.quantity} ${handlingUnit.quantityUnit})`;
}
